import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import Background from './Background';
import { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

function Banners() {

    const [cookies, setCookie] = useCookies(['user']);
    const [banners, setBanners] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [editingBanner, setEditingBanner] = useState(null);
    const [editForm, setEditForm] = useState({ user_id: '', priority: 0, link: '', image: null });
    const [userSearchTerm, setUserSearchTerm] = useState("");
    const [userList, setUserList] = useState([]);
    const [showUserDropdown, setShowUserDropdown] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const userDropdownRef = useRef(null);

    const getBanners = () => {
        setIsLoading(true);
        fetch('https://api.connecker.com/api/get_banners', {
            method: 'POST'
        }).then(res => {
            setIsLoading(false);
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
         }).then(data => {
            setIsLoading(false);
            if(data.response_code == 200) {
               setBanners(data.data);
            } else if(data.response_code == 404) {
                setBanners([]);
            }
         });
    }

    const deleteBannerAPI = (banner_id) => {
        // Note: You'll need to add a delete_banner endpoint in your backend
        // For now, this is a placeholder
        var data = new FormData();
        data.append("banner_id", banner_id);
        setIsLoading(true);
        fetch('https://api.connecker.com/api/delete_banner', {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': `Bearer ${cookies.token}`
            }
        }).then(res => {
            setIsLoading(false);
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
         }).then(data => {
            setIsLoading(false);
            if(data.response_code == 200) {
                toast.success(data.message);
                getBanners();
            } else {
                toast.error(data.message || 'Failed to delete banner');
            }
         }).catch(() => {
            setIsLoading(false);
            toast.error('Failed to delete banner');
         });
    }

    const deleteBanner = (banner_id) => {
        const result = window.confirm('Are you sure you want to delete this banner?');
        if (result) {
            deleteBannerAPI(banner_id);
        }
    }

    const searchUsers = (searchTerm) => {
        if (!searchTerm || searchTerm.length < 2) {
            setUserList([]);
            return;
        }

        var data = new FormData();
        data.append("sort_by", "created_at");
        data.append("sorting_order", "desc");
        data.append("page", 1);
        data.append("page_size", 20);
        data.append("search_term", searchTerm);

        fetch('https://api.connecker.com/api/get_all_users', {
            method: 'POST',
            body: data
        }).then(res => {
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
        }).then(data => {
            if(data.response_code == 200) {
                setUserList(data.data.data || []);
                setShowUserDropdown(true);
            } else {
                setUserList([]);
            }
        }).catch(() => {
            setUserList([]);
        });
    };

    const handleUserSearchChange = (e) => {
        const value = e.target.value;
        setUserSearchTerm(value);
        if (value) {
            searchUsers(value);
        } else {
            setUserList([]);
            setShowUserDropdown(false);
            setSelectedUser(null);
            setEditForm(prev => ({ ...prev, user_id: '' }));
        }
    };

    const selectUser = (user) => {
        setSelectedUser(user);
        setEditForm(prev => ({ ...prev, user_id: user.id }));
        setUserSearchTerm(
            user.middle_name != null && user.middle_name != "null" ? 
                (user.first_name + " " + user.middle_name + " " + user.last_name) : 
                (user.first_name + " " + user.last_name)
        );
        setShowUserDropdown(false);
    };

    const openEditModal = (banner) => {
        setEditingBanner(banner);
        const userName = banner.user ? (
            banner.user.middle_name != null && banner.user.middle_name != "null" ? 
                (banner.user.first_name + " " + banner.user.middle_name + " " + banner.user.last_name) : 
                (banner.user.first_name + " " + banner.user.last_name)
        ) : '';
        setUserSearchTerm(userName);
        setSelectedUser(banner.user || null);
        setEditForm({
            user_id: banner.user_id || '',
            priority: banner.priority || 0,
            image: null
        });
    };

    const closeEditModal = () => {
        setEditingBanner(null);
        setEditForm({ user_id: '', priority: 0, link: '', image: null });
        setUserSearchTerm("");
        setSelectedUser(null);
        setShowUserDropdown(false);
    };

    const handleEditFormChange = (field, value) => {
        setEditForm(prev => ({ ...prev, [field]: value }));
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setEditForm(prev => ({ ...prev, image: e.target.files[0] }));
        }
    };

    const editBannerAPI = (e) => {
        e.preventDefault();
        if (!editingBanner) return;
        var data = new FormData();
        data.append("banner_id", String(editingBanner.id));
        if (editForm.user_id) {
            data.append("user_id", String(editForm.user_id));
        }
        if (editForm.priority !== null && editForm.priority !== undefined) {
            data.append("priority", String(editForm.priority));
        }
        if (editForm.link !== undefined) {
            data.append("link", editForm.link || '');
        }
        if (editForm.image) {
            data.append("image", editForm.image);
        }
        setIsLoading(true);
        fetch('https://api.connecker.com/api/update_banner', {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': `Bearer ${cookies.token}`
            }
        }).then(res => res.json()).then(data => {
            setIsLoading(false);
            if (data.response_code === 200) {
                toast.success(data.message);
                closeEditModal();
                getBanners();
            } else {
                toast.error(data.message || 'Failed to update banner');
            }
        }).catch(() => {
            setIsLoading(false);
            toast.error('Failed to update banner');
        });
    };

    useEffect(() => {
        getBanners();
       },[]);

    return(
        <div className="content">
            <div className="row justify-content-start">
                <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10" style={{ paddingLeft: "40px" }}>
                    <Background></Background>
                    <div className="d-flex justify-content-between align-items-center" style={{ marginTop: "50px" }}>
                        <h4 className="heading" style={{ color:"white" }}>Banners</h4>
                        <Link to="/add_banner">
                            <button 
                                className="btn"
                                style={{
                                    backgroundColor: "#FF4500",
                                    color: "white",
                                    border: "1px solid #FF4500",
                                    borderRadius: "25px",
                                    padding: "10px 20px",
                                    fontWeight: "500"
                                }}
                            >
                                Add Banner
                            </button>
                        </Link>
                    </div>
                    
                    {/* Table */}
                    <div className="card" style={{ borderColor:"white", marginTop: "20px" }}>
                        <div className="table-responsive">
                            <table style={{ width:"100%" }} className="table table-striped">
                                <thead style={{ backgroundColor: "#f8f9fa" }}>
                                    <tr style={{ borderBottom: "2px solid #dee2e6" }}>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>#</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>IMAGE</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>USER</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>LINK</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>PRIORITY</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>CREATED AT</th>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>ACTIONS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        banners.length === 0 ? (
                                            <tr>
                                                <td colSpan="7" style={{ padding: "40px", textAlign: "center", color: "#999" }}>
                                                    No banners found
                                                </td>
                                            </tr>
                                        ) : (
                                            banners.map((banner, i) => (
                                                <tr key={banner.id} style={{ borderBottom: "1px solid #eee" }}>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>
                                                        {i+1}
                                                    </td>
                                                    <td style={{ padding: "12px 8px" }}>
                                                        {banner.image ? (
                                                            <img 
                                                                src={`https://api.connecker.com/storage/${banner.image}`}
                                                                alt="Banner"
                                                                style={{
                                                                    width: "100px",
                                                                    height: "60px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "8px"
                                                                }}
                                                            />
                                                        ) : (
                                                            <span style={{ color: "#999", fontStyle: "italic" }}>No image</span>
                                                        )}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>
                                                        {banner.user ? (
                                                            banner.user.middle_name != null && banner.user.middle_name != "null" ? 
                                                                (banner.user.first_name + " " + banner.user.middle_name + " " + banner.user.last_name) : 
                                                                (banner.user.first_name + " " + banner.user.last_name)
                                                        ) : (
                                                            <span style={{ color: "#999" }}>N/A</span>
                                                        )}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>
                                                        {banner.link ? (
                                                            <a 
                                                                href={banner.link} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                style={{ 
                                                                    color: "#007bff",
                                                                    textDecoration: "none",
                                                                    wordBreak: "break-all"
                                                                }}
                                                            >
                                                                {banner.link.length > 30 ? banner.link.substring(0, 30) + '...' : banner.link}
                                                            </a>
                                                        ) : (
                                                            <span style={{ color: "#999", fontStyle: "italic" }}>No link</span>
                                                        )}
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>
                                                        <span style={{
                                                            padding: "4px 12px",
                                                            backgroundColor: "#e9ecef",
                                                            borderRadius: "12px",
                                                            color: "#495057",
                                                            fontSize: "12px",
                                                            fontWeight: "500",
                                                            display: "inline-block"
                                                        }}>
                                                            {banner.priority || 0}
                                                        </span>
                                                    </td>
                                                    <td style={{ padding: "12px 8px", fontSize: "14px", color: "#666" }}>
                                                        {banner.created_at ? new Date(banner.created_at).toLocaleDateString() : '-'}
                                                    </td>
                                                    <td style={{ padding: "12px 8px" }}>
                                                        <button 
                                                            className="btn btn-sm me-1"
                                                            onClick={() => openEditModal(banner)}
                                                            style={{
                                                                backgroundColor: "#0d6efd",
                                                                borderColor: "#0d6efd",
                                                                color: "white",
                                                                fontSize: "12px",
                                                                padding: "6px 12px",
                                                                borderRadius: "6px"
                                                            }}
                                                        >
                                                            Edit
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm"
                                                            onClick={() => deleteBanner(banner.id)}
                                                            style={{
                                                                backgroundColor: "#dc3545",
                                                                borderColor: "#dc3545",
                                                                color: "white",
                                                                fontSize: "12px",
                                                                padding: "6px 12px",
                                                                borderRadius: "6px"
                                                            }}
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Banner Modal */}
            {editingBanner && (
                <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Banner</h5>
                                <button type="button" className="btn-close" onClick={closeEditModal} aria-label="Close"></button>
                            </div>
                            <form onSubmit={editBannerAPI}>
                                <div className="modal-body">
                                    <div className="mb-3" style={{ position: "relative" }} ref={userDropdownRef}>
                                        <label className="form-label">User</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search for user..."
                                            value={userSearchTerm}
                                            onChange={handleUserSearchChange}
                                            onFocus={() => {
                                                if (userSearchTerm && userList.length > 0) {
                                                    setShowUserDropdown(true);
                                                }
                                            }}
                                        />
                                        {showUserDropdown && userList.length > 0 && (
                                            <div 
                                                className="dropdown-menu show"
                                                style={{
                                                    position: "absolute",
                                                    top: "100%",
                                                    left: 0,
                                                    zIndex: 1000,
                                                    width: "100%",
                                                    maxHeight: "200px",
                                                    overflowY: "auto",
                                                    marginTop: "5px"
                                                }}
                                            >
                                                {userList.map((user) => (
                                                    <button
                                                        key={user.id}
                                                        type="button"
                                                        className="dropdown-item"
                                                        onClick={() => selectUser(user)}
                                                        style={{
                                                            padding: "8px 12px",
                                                            border: "none",
                                                            background: "white",
                                                            width: "100%",
                                                            textAlign: "left",
                                                            cursor: "pointer"
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.backgroundColor = "#f8f9fa";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.backgroundColor = "white";
                                                        }}
                                                    >
                                                        {user.middle_name != null && user.middle_name != "null" ? 
                                                            (user.first_name + " " + user.middle_name + " " + user.last_name) : 
                                                            (user.first_name + " " + user.last_name)
                                                        }
                                                        <br />
                                                        <small style={{ color: "#666" }}>{user.email}</small>
                                                    </button>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Priority</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={editForm.priority}
                                            onChange={(e) => handleEditFormChange('priority', Number(e.target.value))}
                                            min="0"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Link</label>
                                        <input
                                            type="url"
                                            className="form-control"
                                            placeholder="https://example.com"
                                            value={editForm.link}
                                            onChange={(e) => handleEditFormChange('link', e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Image (optional - leave empty to keep current)</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={handleImageChange}
                                        />
                                        {editForm.image && (
                                            <div className="mt-2">
                                                <img 
                                                    src={URL.createObjectURL(editForm.image)}
                                                    alt="Preview"
                                                    style={{ maxWidth: "200px", maxHeight: "150px", borderRadius: "8px" }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={closeEditModal}>Cancel</button>
                                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                        {isLoading ? 'Saving...' : 'Save changes'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <ToastContainer />
        </div>
    )
}

export default Banners;
